import React from 'react';
import { GraduationCapIcon } from 'lucide-react';
const MOCKUP_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/jbnWXFE7WM5N12A9oKvrTY/Texto_del_parrafo_(4).webp';
export function Hero() {
  return <section className="relative pt-3 pb-12 md:pt-5 md:pb-20 overflow-hidden bg-background" aria-label="Presentación de Matemáticas Sin Lágrimas" style={{
    contain: 'layout'
  }} data-id="element-157">
      {/* Soft warm background blobs */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0" data-id="element-158">
        <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-primary/10 blur-[100px] rounded-full" data-id="element-159" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] bg-amber/10 blur-[100px] rounded-full" data-id="element-160" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-161">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-162">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 mb-4 rounded-full border border-primary/30 bg-primary/10" data-id="element-163">
            <GraduationCapIcon className="w-4 h-4 text-primary-dark" data-id="element-164" />
            <span className="text-primary-dark text-xs font-bold uppercase tracking-widest" data-id="element-165">
              MATEMÁTICAS SIN LÁGRIMAS
            </span>
          </div>

          <h1 className="font-heading md:text-6xl lg:text-7xl font-extrabold mb-6 text-slate-900 tracking-tight text-[26px]" data-id="element-166">
            Todo el acompañamiento matemático de tu hijo listo.{' '}
            <span className="text-primary" data-id="element-167">Desde hoy.</span>
          </h1>

          {/* Product Mockup — right after the title */}
          <div className="relative w-full max-w-2xl mb-6" data-id="element-168">
            <div className="absolute inset-0 z-0 pointer-events-none" aria-hidden="true" style={{
            background: 'radial-gradient(circle at center, rgba(45,212,191,0.25) 0%, rgba(45,212,191,0) 65%)',
            filter: 'blur(30px)'
          }} data-id="element-169" />
            <img src={MOCKUP_IMAGE_URL} alt="Matemáticas Sin Lágrimas — El sistema completo: 5 Tomos, bonos, Kit Acelerador y recursos imprimibles" className="relative z-10 w-full h-auto mx-auto drop-shadow-[0_20px_50px_rgba(15,23,42,0.15)] hover:scale-[1.02] transition-transform duration-500" width={1024} height={1024}
          // @ts-ignore
          fetchpriority="high" decoding="async" loading="eager" data-id="element-170" />
          </div>

          <p className="md:text-lg mb-6 text-slate-600 font-medium max-w-2xl text-[15px]" data-id="element-171">
            El sistema para padres de niños de 8 a 11 años: métodos visuales y
            sesiones de 10 minutos que terminan en victoria.{' '}
            <strong className="text-slate-900" data-id="element-172">
              Sin improvisar ni pelear más.
            </strong>
          </p>

          <button onClick={() => {
          const target = document.getElementById('elegir-plan');
          if (!target) return;
          const offset = 24;
          const startY = window.scrollY || window.pageYOffset;
          const duration = 1200;
          let startTime: number | null = null;
          let cancelled = false;
          const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          const destOf = () => target.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - offset;
          // Cancel only if the user actively scrolls with the wheel
          // (desktop). On mobile we intentionally do NOT bind touchstart,
          // because the tap that launches the scroll would cancel it
          // instantly and leave the page short of the target.
          const cancel = () => {
            cancelled = true;
            window.removeEventListener('wheel', cancel);
          };
          window.addEventListener('wheel', cancel, {
            passive: true
          });
          const step = (now: number) => {
            if (cancelled) return;
            if (startTime === null) startTime = now;
            const progress = Math.min((now - startTime) / duration, 1);
            const eased = easeInOutCubic(progress);
            // Recompute the destination every frame so scroll-triggered
            // animations / image loads that shift layout don't throw the
            // landing position off.
            const nextY = startY + (destOf() - startY) * eased;
            window.scrollTo(0, nextY);
            if (progress < 1) {
              requestAnimationFrame(step);
            } else {
              window.removeEventListener('wheel', cancel);
              // Correct for any layout settle that finished just after the
              // animation, so we always land exactly on the options.
              setTimeout(() => {
                if (!cancelled) window.scrollTo(0, destOf());
              }, 80);
            }
          };
          requestAnimationFrame(step);
        }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 text-lg font-bold text-white bg-amber rounded-2xl hover:bg-amber-dark transition-all duration-300 shadow-glow-amber hover:-translate-y-1 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber mb-10" data-id="element-173">
            QUIERO ACCEDER YA
          </button>

          <div className="flex flex-wrap justify-center gap-3 mb-6" role="list" data-id="element-174">
            {[{
            icon: '📄',
            text: '100% PDF'
          }, {
            icon: '⚡',
            text: 'Acceso en 5 min'
          }, {
            icon: '🇦🇷',
            text: 'Tablas → Divisiones → Fracciones'
          }, {
            icon: '👨‍👧',
            text: 'Para Padres'
          }].map((item, i) => <div key={i} className="flex items-center gap-2 bg-white px-4 py-2 rounded-xl shadow-sm border border-slate-100" role="listitem" data-id="element-175">
                <span className="text-lg" aria-hidden="true" data-id="element-176">
                  {item.icon}
                </span>
                <span className="font-bold text-sm text-slate-700" data-id="element-177">
                  {item.text}
                </span>
              </div>)}
          </div>

          <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-slate-500 font-medium" data-id="element-178">
            <div className="flex items-center gap-2" data-id="element-179">
              <span className="text-primary text-lg" aria-hidden="true" data-id="element-180">
                🛡️
              </span>
              <span data-id="element-181">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-182">
              <span className="text-primary text-lg" aria-hidden="true" data-id="element-183">
                🔒
              </span>
              <span data-id="element-184">Pago seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-185">
              <span className="text-primary text-lg" aria-hidden="true" data-id="element-186">
                💳
              </span>
              <span data-id="element-187">Mercado Pago</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}